import _ from 'lodash';
import React, {FC} from 'react';

import {isElectron} from '../../../../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {AttachmentStatusesEnum} from '../../../../../../libs/shared/core/src/models/api/attachmentModel';
import {LoadedMessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {reportToBugsnag} from '../../../../../../libs/shared/core/src/services/bugsnag/bugsnag';
import {TimelineVariationsEnum} from '../../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {findVisibleAttachments} from '../../../../../helpers/models/messageHelpers';
import {downloadAttachmentAsync, downloadFileAsync} from '../../../../../services/browser';
import {getCompany} from '../../../../../store/data/company/companySelectors';
import {MessageViewerAttachments} from './messageViewerAttachments';

/*
 * Props.
 */

interface MessageViewerAttachmentsContainerProps {
  message: LoadedMessageModel;
  timelineVariation: TimelineVariationsEnum;
  shouldScroll: boolean;
}

/*
 * Component.
 */

export const MessageViewerAttachmentsContainer: FC<MessageViewerAttachmentsContainerProps> = (props) => {
  const {message} = props;
  const attachments = findVisibleAttachments(message);
  const company = useAppSelector(getCompany);

  const onDownloadAllClick = async () => {
    try {
      if (isElectron()) {
        const downloadAttachmentPromises = _(attachments)
          .map((a) => a.status === AttachmentStatusesEnum.UPLOADED && a)
          .compact()
          .map((a) => downloadAttachmentAsync(a))
          .value();

        await Promise.all(downloadAttachmentPromises);
      } else {
        downloadFileAsync(`${company.url}/messages/${message.uid}/attachments-as-zip`, '');
      }
    } catch (error) {
      reportToBugsnag(error);
    }
  };

  return (
    <MessageViewerAttachments
      attachments={attachments}
      timelineVariation={props.timelineVariation}
      shouldScroll={props.shouldScroll}
      onDownloadAllClick={onDownloadAllClick}
    />
  );
};
